import React from 'react';
import { Card, List, Typography } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import MapComponent from '../MapComponent';
import type { GpsData, PhotoData } from '../../types/dashboard';

const { Text } = Typography;

interface GpsSectionProps {
  gpsData: GpsData[];
  photoData: PhotoData[];
  debugData?: any;
}

const GpsSection: React.FC<GpsSectionProps> = ({ gpsData, photoData, debugData }) => {
  const currentLocation = gpsData.length > 0 ? gpsData[gpsData.length - 1] : undefined;

  return (
    <>
      <Card title={<><EnvironmentOutlined /> 地図表示</>} style={{ marginBottom: 16 }}>
        <div style={{ height: 500, width: '100%', overflow: 'hidden' }}>
          <MapComponent 
            gpsData={gpsData} 
            photoData={photoData}
            currentLocation={currentLocation}
          />
        </div>
      </Card>
      
      <Card title={<><EnvironmentOutlined /> GPS履歴 ({gpsData.length}件)</>} style={{ marginBottom: 16 }}>
        <details style={{ marginBottom: 8, fontSize: '12px' }}>
          <summary>🔍 GPS API応答</summary>
          <pre style={{ background: '#f5f5f5', padding: 8, fontSize: '10px', overflow: 'auto', maxHeight: 200 }}>
            {JSON.stringify(debugData?.gps, null, 2)}
          </pre>
        </details>
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
          <List
            dataSource={gpsData.slice(0, 10)}
            size="small"
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  avatar={<EnvironmentOutlined style={{ color: '#faad14' }} />}
                  title={`${item.latitude.toFixed(6)}, ${item.longitude.toFixed(6)}`}
                  description={
                    <div>
                      <div>高度: {item.altitude?.toFixed(1)}m | 精度: {item.accuracy?.toFixed(1)}m</div>
                      <div style={{ fontSize: '12px', color: '#999' }}>
                        {new Date((item.measured_at || '').replace(/Z$/, '')).toLocaleString()}
                      </div>
                    </div>
                  }
                />
              </List.Item>
            )}
            locale={{ emptyText: 'GPS データがありません' }}
          />
        </div>
        {gpsData.length > 10 && (
          <div style={{ textAlign: 'center', marginTop: 8, paddingTop: 8, borderTop: '1px solid #f0f0f0' }}>
            <Text type="secondary">他 {gpsData.length - 10} 件</Text>
          </div>
        )}
      </Card>
    </>
  );
};

export default GpsSection;